import type { Config } from "../../common/interfaces/config";
import type { EntraAuthConfigs } from "../../common/interfaces/impersonation";

export const loadEntraAuthConfigs = (defaultConfig: Config): EntraAuthConfigs => ({
  AuthUrlBase: defaultConfig.entraAuthUrlBase,
  TokenUrl: defaultConfig.entraTokenUrl,
  ClientId: defaultConfig.entraClientId,
  TenantId: defaultConfig.entraTenantId,
  Scope: defaultConfig.entraScope,
  RedirectUri: defaultConfig.entraRedirectUri,
  TokenApiUrlBase: defaultConfig.apiBasePaths?.oktaToken
    ? defaultConfig.apiBaseUrl + defaultConfig.apiBasePaths.oktaToken
    : "",
});
